/* Aboreo — animaciones al hacer scroll: fade-up, texto por palabra y parallax.
   Sin dependencias externas (IntersectionObserver + requestAnimationFrame). */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Fade-up al entrar en pantalla */
  var revealTargets = document.querySelectorAll('.aboreo-reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealTargets.forEach(function (el) { io.observe(el); });
  }

  /* 2. Texto dividido en palabras, cada una con su propio delay */
  var wordRoots = document.querySelectorAll('.aboreo-reveal-words');
  wordRoots.forEach(function (root) {
    if (root.dataset.aboreoSplit) return;
    root.dataset.aboreoSplit = 'true';

    var words = root.textContent.split(/(\s+)/);
    root.textContent = '';
    var index = 0;
    words.forEach(function (word) {
      if (!word) return;
      if (/^\s+$/.test(word)) {
        root.appendChild(document.createTextNode(word));
        return;
      }
      var span = document.createElement('span');
      span.className = 'aboreo-reveal-word';
      span.textContent = word;
      span.style.setProperty('--aboreo-word-delay', (index * 60) + 'ms');
      root.appendChild(span);
      index++;
    });

    if (reduce || !('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }
    var ioWords = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('is-visible');
          ioWords.unobserve(root);
        }
      });
    }, { threshold: 0.25 });
    ioWords.observe(root);
  });

  /* 3. Parallax de imágenes dentro de .aboreo-parallax */
  if (reduce) return;
  var parallaxTargets = document.querySelectorAll('.aboreo-parallax');
  if (!parallaxTargets.length) return;

  var ticking = false;
  var visible = new Set();
  var ioParallax = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
  }, { rootMargin: '20% 0px 20% 0px' });
  parallaxTargets.forEach(function (t) { ioParallax.observe(t); });

  function update() {
    var vh = window.innerHeight;
    visible.forEach(function (root) {
      var img = root.querySelector('img');
      if (!img) return;
      var rect = root.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / (vh / 2 + rect.height / 2);
      progress = Math.max(-1, Math.min(1, progress));
      var shift = -progress * 12;
      img.style.transform = 'translate3d(0,' + shift + '%, 0)';
    });
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
